import dayjs from 'dayjs'

export const Date = (value, format = 'DD.MM.YYYY') => {

    return value && format && value != '0000-00-00' && value != '0000-00-00 00:00:00' ? dayjs(value).format(format) : ''
}